import React from 'react';
import { put, call, takeLatest, select, take, actionChannel, takeEvery } from "redux-saga/effects";
import * as Api from "../api";
import * as UserApi from "../../AdminPanel/features/users/usersAPI"
import * as ActionConstants from "../actions/actionConstants";
import { ErrorCode, noteFilterConstants } from "../constants";
import { logout ,getWorkkardDetailMasterData, fetchUserDetail } from './common';
import * as menuhelpers from '../../../common/menuHelper';
import { normalizePermissions } from '../../../common/normalizers/userPermission';
import { getOrgs } from '@/common/sagas/orgListSaga';
import { mapActivityListingModel } from '../slice';
import { normalizeCustomField } from '../../../common/normalizers/workkardFields';
import { normalizeActivityTimeZones } from '../../../common/util';

export function* getActivityListingData({payload}){
    try{
      const isForReopenWk = payload.isForReopenWk ? payload.isForReopenWk : false;
      // const isForReopenWk = true;
      yield put({ type:ActionConstants.SHOW_LISITNG_LOADER })
      const apiResponse = yield call(Api.getActivityListByClaim, payload);
      const { status, activities, total } = apiResponse || {};
      
      if (status == 200) {        
        if (activities) {
          const tzData = yield select((state) => state.sessionContextOidc?.tzData);
          const normalizedActivities = normalizeActivityTimeZones(activities, tzData);
          const normalizedActivityData = {
            Activities: normalizedActivities,
            Total: total
          };
          
          if (isForReopenWk) {
            const getItems = (state) => state.sessionContextOidc.userView;
                  const userView = yield select(getItems);
                     let filteredClosedActList = normalizedActivities.filter((item)=>  (((item.resolution || "").toLowerCase() !== "reassigned closed" &&  (item.resolution || "").toLowerCase() !== "reassignedclosed")
                                                 && (((item.assignee_org_id== item.owner_org_id) &&
                                                 (userView.orgId==item.assignee_org_id || userView.orgId==item.owner_org_id))
                                                 || userView.orgId==item.owner_org_id )));
      
                                                  
                    let  newactivityData =  Object.assign({}, normalizedActivityData,{Activities:filteredClosedActList, showReopenActivityOption : filteredClosedActList.length > 0 });

            const reopenUserIds = filteredClosedActList.reduce((acc, item) => {
              if (item.activity_owner_id) acc.push(item.activity_owner_id);
              if (item.activity_assignee_id) acc.push(item.activity_assignee_id);
              return acc;
            }, []);
            yield* fetchUserDetail({ uniqueUserIds: Array.from(new Set(reopenUserIds)) });

            yield put({
              type: ActionConstants.CLOSE_ACTIVITY_LISTING_SUCCESS,
              payload: newactivityData
            });
          } 
          else {
            const actionPayload = { skip: payload.skip || 0, take: payload.take || 15, ...normalizedActivityData };  
            const workkard = yield select((state) => state.workkardDetail.workkardDetail);
            const sponsorId = workkard?.Sponsor;
            const activityUserIds = activities.reduce((acc, item) => {
              if (item.ActivityAssigneeId) acc.push(item.ActivityAssigneeId);
              if (item.ActivityOwnerId) acc.push(item.ActivityOwnerId);
              return acc;
            }, []);
            const uniqueUserIds = Array.from(new Set([...(sponsorId ? [sponsorId] : []), ...activityUserIds]));
            yield* fetchUserDetail({uniqueUserIds});

            const activityOrgIds = activities.reduce((acc, item) => {
              if (item.AssigneeOrgId) acc.push(item.AssigneeOrgId);
              if (item.OwnerOrgId) acc.push(item.OwnerOrgId);
              return acc;
            }, []);
            if (activityOrgIds.length > 0) {
              yield* getOrgs(Array.from(new Set(activityOrgIds)));
            }
            yield put({
              type: ActionConstants.ACTIVITY_LISTING_SUCCESS,
              payload: actionPayload
            });
          }
          var activityids = activities.map((obj) => {
            return obj.activity_id;
          }).join(",");
          var templatePayload = {
            actIds: activityids
          };
          const res = yield call(Api.getActivityNoteTemplates, templatePayload);
          var exfilters = {}
          const getMiddlePanelData=(state)=>state.workkardDetail.middlePanel;
          const middlePanelData=yield select(getMiddlePanelData); 
          let ActivityTemplates = Array.from(new Set(activities.map(x => x.activity_template_type)));
          ActivityTemplates.forEach((e) => {
            if (middlePanelData.excludedFilters[e] == undefined) {
              exfilters[e] = middlePanelData.excludedFilters[0]
            } else {
              exfilters[e] = middlePanelData.excludedFilters[e];
            }
          });
          yield put({
            type: ActionConstants.ACTIVITY_NOTE_TEMPLATES_SUCCESS,
            payload: { activityNoteTemplates: res.noteTemplates, excludedFilters: exfilters }
          });
        }
      } else if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
          yield put({
            type: ActionConstants.LOG_APPLICATON_ERROR,
            payload: { status:status, isErrorScreen:false  }
          });
        }
  
    }
    catch(error){
      yield put({ type: ActionConstants.ACTIVITY_LISTING_ERROR, payload: {errorMessage: error } });
    }
    finally{
      yield put({ type:ActionConstants.HIDE_LISITNG_LOADER})
    }
}

export function* getActivityDetail({ payload }) {
    try {
      const activityListing = yield select((state) => state.workkardDetail.activityListing);
      const activityFromListing = payload.force
        ? null
        : activityListing.activities?.find((act) => act.activityId == payload.actId);

      let activityDetail;
      let status = 200;
      let usedListing = false;
      const actResp = [];
      if (activityFromListing) {
        activityDetail = {
          ...activityFromListing,
          customFields: (activityFromListing.customFields || []).map(normalizeCustomField),
        };
        usedListing = true;
      } else {
        const response = yield call(Api.getActivityDetail, payload.actId);
        if(response && response?.activity_detail){
          actResp.push(response.activity_detail);
          activityDetail = mapActivityListingModel(actResp)[0];
          activityDetail.customFields = (activityDetail.customFields || []).map(normalizeCustomField);
        }
        status = response.status;
      }

      if(status == 200){
        yield* fetchUserDetail({ uniqueUserIds: [activityDetail.activityOwnerId, activityDetail.activityAssigneeId].filter(Boolean) });
        yield* getOrgs([activityDetail.ownerOrgId, activityDetail.assigneeOrgId].filter(Boolean));
        let userSessionContext = yield select((state) => state.sessionContextOidc);
        let userList = yield select((state) => state.userList);
        const editPermissions = {
            canEditActivityTemplate : userSessionContext?.userTemplates.find((item) => item.id == activityDetail.templateId && item.module == "Activity") ? true : false,
            isDefaultTemplate : activityDetail.templateId == 0
        };
        let isAssigneeBlocked = activityDetail.activityAssigneeId == 0 ? false : !userList[activityDetail.activityAssigneeId]?.is_active;
        activityDetail.activityActions = menuhelpers.getActivityActions(activityDetail, userSessionContext.userView.orgId, normalizePermissions(userSessionContext.userView.permissions), !userList[activityDetail.activityOwnerId]?.is_active, isAssigneeBlocked, editPermissions);
        if (activityDetail) {
          yield put({ type: ActionConstants.ACTIVITY_DETAIL_FULL_REPLACE, payload: activityDetail });
        }
        if(payload.referrer){
          yield getWorkkardDetailMasterData({ payload: { cId:activityDetail.WorkkardId,doNotUpdateActivityListing:true  }});
        }
        if(payload.callback){
          payload.callback(activityDetail);
        }
        if (!usedListing) {
          yield put({ type: ActionConstants.UPDATE_ACTIVITY_STATUS_SUCCESS, payload: activityDetail });
        }
      } 
      else if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
        // yield put({ type: ActionConstants.ACTIVITY_DETAIL_DATA_ERROR, payload: {errorMessage: WorkkardErrorConstant.ACTIVITY_DETAIL_DATA_ERROR[status]} });
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status : status, isErrorScreen:true  }
        });
      }
  
    }
    catch (error) {
      console.log(error)
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: error
      });
      // yield put({ type: ActionConstants.ACTIVITY_DETAIL_DATA_ERROR, payload: {errorMessage: error} });
    }
    finally {
  
    }
}

function normalizeActivityTemplatePermissions(
  permissions = [],
  templates = []
) {
  const templateMap = templates.reduce((map, template) => {
    map[template.template_id] = template;
    return map;
  }, {});

  return permissions
    .filter((permission) => permission.template_type === "CreateActivity")
    .map((permission) => {
      const template = templateMap[permission.template_id] || {};

      return {
        Id: permission.template_id ?? 0,
        TemplateShortName: template.template_short_name ?? "",
        TemplateName: template.name ?? "",
      };
    })
    .sort((a, b) => a.TemplateName.localeCompare(b.TemplateName));
}

export function* getActivityTemplatesList({payload}){
    try{
      yield put({ type: ActionConstants.BUTTON_LOADER, payload: { activityTemplate: true}});
      const response = yield call(UserApi.fetchUserTemplates);
      if(typeof response === 'object'){
        const sessionContext=(state)=>state.sessionContextOidc;
        const context=yield select(sessionContext);
        const activityTemplates = normalizeActivityTemplatePermissions(
          context.userTemplates,
          response          
        );
        yield put({ type: ActionConstants.FETCH_ACTIVITY_TEMPLATES_LIST_SUCCESS, payload: {templates: activityTemplates} });
      } else if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
          yield put({
            type: ActionConstants.LOG_APPLICATON_ERROR,
            payload: { status:status, isErrorScreen:false  }
          });
        }
      yield put({ type: ActionConstants.BUTTON_LOADER, payload: { activityTemplate: false}});
    }
    catch (error) {
      yield put({ type: ActionConstants.BUTTON_LOADER, payload: { activityTemplate: false}});  
    }
}

export function* updateActivityListingData({ cId }) {
    try {
      const getItems = (state) => state.workkardDetail.activityListing;
      const items = yield select(getItems);
      const listingObj = {
        skip: 0,
        take: items.skip + items.take,
        cId: cId
      }
      const apiResponse = yield call(Api.getActivityListByClaim, listingObj)
      const { status, activities, Activities, total, Total } = apiResponse || {};
      
      if(status == 200){
        if (activities && activities.length) {
          const tzData = yield select((state) => state.sessionContextOidc?.tzData);
          const normalizedActivityData = {
            Activities: normalizeActivityTimeZones(activities, tzData),
            Total: total
          };
          
          yield put({
            type: ActionConstants.UPDATE_ACTIVITY_LISTING_SUCCESS,
            payload: { skip: items.skip || 0, take: items.take, ...normalizedActivityData }
          });
        }
      } else if(status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:status, isErrorScreen:false  }
        });
      }
      
    }
    catch (error) {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: error
      });
    }
    finally {
  
    }
}



export default [
    takeLatest(ActionConstants.ACTIVITY_LISTING_DATA, getActivityListingData),
    takeLatest(ActionConstants.FETCH_ACTIVITY_DETAIL_DATA, getActivityDetail),
    takeLatest(ActionConstants.FETCH_ACTIVITY_TEMPLATES_LIST, getActivityTemplatesList),
  ];
  